// extracted by mini-css-extract-plugin
export var paginationContainer = "_98-0";